module.exports = __webpack_public_path__ + "static/three-5191de0aaa16f4385084ef5505e7e6bc.png";